import { Component, OnDestroy, OnInit, Input, ElementRef, Output, EventEmitter, OnChanges } from '@angular/core';
import { MysqlService } from './../../../services/mysql.service';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { environment } from './../../../../environments/environment';



@Component({
  selector: 'app-user-avitar-modal-upload',
  templateUrl: './user-avitar-modal-upload.component.html',
  styleUrls: ['./user-avitar-modal-upload.component.css']
})
export class UserAvitarModalUploadComponent implements OnInit {


  @Input() title = 'Upload Below';
// as a model vars
  @Input() item_id: number;
  @Input()  closeBtnName: string;
  @Input() list: any[] = [];
  @Input() user_id: number;


loading: boolean;
// set an event emitter to send back to parent component
@Output() action = new EventEmitter();

sessionBrandId: any;
sessionUsername: any;
sessionUserId: any;
currentUserVAR: any;

div: any;
public nav: any;
public body: any;
public container: any;
// Uploader Service Vars
// public title = 'File Upload Manager - Brands';
// public imgUploaded: string;
public tableData: any;
public baseUploadURL = environment.baseUploadURL_UserAssets; // no trailing slash // added brand_id to HTML 


  constructor(   private _mysqlService: MysqlService, private route: ActivatedRoute, private router: Router,
    private fileUploader: FileUploaderService, private elem: ElementRef, public bsModalRef: BsModalRef,
    private modelService: BsModalService) { 
      this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
console.log('sessionUserId: ', this.currentUserVAR.user_id );
console.log('sessionUsername: ', this.currentUserVAR.username );
// Set loggind in User Value (USER ID)
this.sessionUserId = this.currentUserVAR.user_id;
this.sessionUsername = this.currentUserVAR.username;
this.sessionBrandId = this.currentUserVAR.brand_id; 
    }

  ngOnInit() {
  }

// Uploader Functions
public uploadUserImage(user_id): void {
  this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
let files = this.elem.nativeElement.querySelector('#selectFile').files;
let formData = new FormData();
let file = files[0];
formData.append('selectFile', file, file.name);
this.fileUploader.uploadUserImage(formData, user_id).subscribe(res=> this.dataLoaded(res));

}


dataLoaded(data: any): void {
this.elem.nativeElement.querySelector('#spinner').style.visibility='hidden';
 // this.imgUploaded = data._body;
this.refreshList();
}

refreshList(): void {
this.fileUploader.getUsersList(this.user_id).subscribe(res=> this.displayTableData(res));

}

displayTableData(data: any): void {
this.tableData = data.json();
}

// end uploader functions


loadList(user_id): void {
  this.fileUploader.getUsersList(user_id).subscribe(res=> this.displayTableData(res));
  
  }



public clickOk() {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.action.emit(true); /// << here you can send object  instead of true
}


public clickFile(filename) {
  // tslint:disable-next-line:indent
  this.loading = true;
  this.action.emit(filename); /// << here you can send object  instead of true
  this.bsModalRef.hide();
}





}
